/**
 * O comanda validata sau respinsa nu mai poate fi editata de admin -- backendul (BE-M14)
 * raspunde cu 409 pe admin-update in starea asta. Butonul „Editare" din
 * `WasteOrdersReportPage.tsx` se ascunde dupa aceeasi regula ca „Validare"/„Respingere".
 */
export function poateEditaComanda(isValidated: boolean | null | undefined): boolean {
    return !isValidated;
}
